import React, {useEffect, useState, useRef, Fragment} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import axios from 'axios'
import Step1 from './step1';
import Step2 from './step2';
import Step2b from './step2-b';
import Step2c from './step2-c';
import Step3 from './step3';
import './questions.scss';
import questions from './questions'
import CurrencyInput from "../../utils/currency-input";
import Loader from "react-loader-spinner";
import Results from "../results/results";
import {even} from '../results/even-api-loan-response'
import MaskedInput from 'react-text-mask'
import {Controller as SceneController, Scene} from 'react-scrollmagic';
import uuid from 'react-uuid'
import {useParams} from 'react-router-dom'

const Questions = (props) => {

    const progressDot = useRef(null);
    let {partner_name_param} = useParams();

    const [answers, setAnswers] = useState([{}]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const LoanForm = useForm({
        shouldFocusError: true,
        mode: 'onSubmit',
        reValidateMode: 'onChange',
    });


    const register = LoanForm.register;
    const getValues = LoanForm.getValues;
    const setValue = LoanForm.setValue;
    const control = LoanForm.control;
    const errors = LoanForm.formState.errors;
    const reset = LoanForm.reset;

    const [displayForm, setDisplayForm] = useState(true);
    const [displayResults, setDisplayResults] = useState(false);
    const [loadingResults, setLoadingResults] = useState(false);
    // const [results, setResults] = useState(even);
    const [results, setResults] = useState(null);

    const [session_uuid, setSession_uuid] = useState(null);
    const [errorIndex, setErrorIndex] = useState([])
    const [formErrors, setFormErrors] = useState([])
    // uncomment when testing the results

    const [currency, setCurrency] = useState([])
    const [partnerName, setPartnerName] = useState(null)

    // React.useEffect(() => {
    //     // console.log('answers', answers)
    //
    //     answers[currentIndex]['answer'] && moveDot();
    // }, [answers]);

    useEffect(() => {
        setSession_uuid(uuid())
        if (partner_name_param) {
            // console.log('partner', partner_name_param)
            setPartnerName(partner_name_param);
        }

    }, []);


    const validateCurrencyAmount = (amount, rules) => {
        const strippedAmount = parseInt(amount.replace(/[$,]/g, ''));
        return strippedAmount <= rules.max && strippedAmount >= rules.min;
    }
    const validateInputConfirmation = (value, confirmValue) => {
        // console.log(value, confirmValue, getValues(confirmValue))
        const v = answers.find(m => m && m.name === confirmValue);
        if (v) {
            return value.toLowerCase().replace(' ', '') === v.answer.toLowerCase().replace(' ', '')
        } else {
            return false
        }


    }
    const validateNumber = (value, max) => {
        const strippedNumber = value.replace(/\D/g, '');
        return strippedNumber.length === max
    }


    const focusDot = (index) => {
        addActiveClass(index);
        questions.forEach((q, i) => {
            i !== index && removeActiveClass(i)
        });

        let currentTopPosition = progressDot.current.style.top;
        let topPosition = questions[index]['top'];
        // console.log(topPosition)

        // addActiveClass(index)
        // animate the dot
        animateDot(currentTopPosition, topPosition);
    };


    const animateDot = (currentTopPosition, topPosition) => {
        progressDot.current.style.top = topPosition + "%";
        progressDot.current.animate([
            // keyframes
            {top: `${currentTopPosition}`},
            {top: `${topPosition}%`}
        ], {
            // timing options
            duration: 1500,
            // iterations: Infinity,
            fill: "forwards",
            easing: "cubic-bezier(0.36, 0, 0.66, -0.28)"
        });
    }

    const addActiveClass = (index) => {
        document.getElementById(`q-${index}`).className += ' active';
    }

    const removeActiveClass = (index) => {
        document.getElementById(`q-${index}`).className = questions[index]['classNames'];
    }

    const addErrorClass = (index) => {
        let currentState = errorIndex.slice();
        currentState.push(index);
        setErrorIndex(currentState)
        document.getElementById(`q-${index}`).className += ' error';
    }

    const removeErrorClass = (index) => {
        let currentStateIndex = errorIndex.indexOf(index);

        if (currentStateIndex > -1) {
            errorIndex.splice(currentStateIndex, 1);
        }
        setErrorIndex(errorIndex)

        document.getElementById(`q-${index}`).className = questions[index]['classNames'];
    }

    const moveDot = () => {

        let currentTopPosition = progressDot.current.style.top;
        let topPosition = 0;
        // iterate through the answers to find the next one that needs to be answered
        for (const [index, value] of answers.entries()) {
            if (value.answer === null && value.required) {
                topPosition = questions[index]['top'];
                addActiveClass(index);
                break;
            }

        }

        // animate the dot
        animateDot(currentTopPosition, topPosition)
    }


    const saveAnswer = (value, index, question) => {
        // remove active class

        removeActiveClass(index);
        removeErrorClass(index)

        if (question.type === 'select' && value !== 'select') {
            addActiveClass(index)
        }

        if (question.type === 'currency' && value.length > 3) {
            setCurrency({'name': question.register, 'value': value})
            validateCurrencyAmount(value, question.rules) ? addActiveClass(index) : addErrorClass(index)
        }

        if (question.type === 'text' && value.length > 3) {
            if (question.rules && question.rules.hasOwnProperty('confirm')) {
                validateInputConfirmation(value, question.rules.confirm) ? addActiveClass(index) : addErrorClass(index)
            } else {
                addActiveClass(index)
            }
        }

        if (question.type === 'phone' && validateNumber(value, 10)) {
            addActiveClass(index)
        }
        if (question.type === 'date' && validateNumber(value, 8)) {
            addActiveClass(index)
        }

        if (question.type === 'social' && validateNumber(value, 9)) {

            if (question.rules && question.rules.hasOwnProperty('confirm')) {
                if (validateInputConfirmation(value, question.rules.confirm)) {
                    blurSocial(index, value)
                    addActiveClass(index)
                } else {
                    addErrorClass(index)
                }
            } else {
                blurSocial(index, value)
                addActiveClass(index)
            }


        }
        // update state with the answer
        let a = [...answers];
        let b = {...a[index]}
        // console.log('B1', b)
        b.answer = value;
        b.name = question.register;
        a[index] = b;
        // console.log('A1', a)
        setAnswers(a);


        setCurrentIndex(index)
    };

    const checkValueExists = (register) => {
        const v = answers.find(m => m && m.name === register);
        if (v) {
            return v.answer;
        } else {
            return null;
        }
    }

    const saveProgress = (save) => {

        if (save) {
            // console.log(getValues('loanAmount'))
            // SEND THE PROGRESS TO THE SERVER
            axios.post('/loans/loan-progress', {
                loanType: checkValueExists('loanType'),
                loanAmount: checkValueExists('loanAmount'),
                estCreditRange: checkValueExists('estCreditRange'),
                firstName: checkValueExists('firstName'),
                lastName: checkValueExists('lastName'),
                streetAddress: checkValueExists('streetAddress'),
                city: checkValueExists('city'),
                state: checkValueExists('state'),
                zip: checkValueExists('zip'),
                email: checkValueExists('email'),
                birthDate: checkValueExists('birthDate'),
                phone: checkValueExists('phone'),
                employmentStatus: checkValueExists('employmentStatus'),
                payFrequency: checkValueExists('payFrequency'),
                annualIndividualIncome: checkValueExists('annualIndividualIncome'),
                housingStatus: checkValueExists('housingStatus'),
                ssn: checkValueExists('ssn'),
                checked: checkValueExists('checked'),
                session_uuid: session_uuid,
                partner_name: partnerName
            }).then((response) => {
                // console.log(response)

                // console.log('loan', response.data.loan)

            }).catch(error => {

                console.log(error)

                // todo: fix this error to display on the client side
                let er = Object.values(error.response.data.errors);
                er = er.flat();
            })
        }
    };

    const blurSocial = (index, value) => {
        if (value.length > 0) {
            document.getElementById(`q-${index}`).className += ' blurry-text';
        }

    }
    const focusSocial = (question, index) => {
        const el = document.getElementById(`q-${index}`);
        el.classList.remove('blurry-text')
        saveProgress(question.save)
    }

    const renderQuestion = (question, index) => {

        if (question && question.type === 'select') {
            return (
                <Fragment key={index}>
                    <select id={`q-${index}`} className={question.classNames}
                            {...register(question.register, {validate: value => value !== "select"})}
                            onFocus={() => saveProgress(question.save)}
                            onChange={(e) => saveAnswer(e.target.value, index, question)}>
                        {
                            question.options.map((q, i) =>
                                (
                                    <option name={q.value} key={i} value={q.value}>{q.label}</option>
                                )
                            )
                        }
                    </select>
                </Fragment>
            )
        }

        if (question && question.type === 'social') {
            return (
                <div className="input--block" key={index}>
                    {
                        errorIndex.includes(index) &&
                        <div className="error--msg">{question.error}</div>
                    }

                    <MaskedInput id={`q-${index}`}
                                 name={question.register}
                                 {...register(question.register, {validate: value => value !== ""})}
                                 inputMode={question.inputMode}
                                 className={question.classNames}
                                 mask={[/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                                 onFocus={() => focusSocial(question, index)}
                                 placeholder={question.question}
                                 onChange={(e) => saveAnswer(e.target.value, index, question)}/>


                </div>
            )
        }

        if (question && question.type === 'currency') {
            return (
                <Fragment key={index}>
                    {
                        errorIndex.includes(index) &&
                        <div className="error--msg">{question.error}</div>
                    }

                    <CurrencyInput id={`q-${index}`}
                                   type="text"
                                   inputMode={question.inputMode}
                                   className={question.classNames}
                                   {...register(question.register, {validate: value => value !== ""})}
                                   onFocus={() => saveProgress(question.save)}
                                   placeholder={question.question}
                                   maskOptions={{integerLimit: question.rules.maxDigits}}
                                   onChange={(e) => saveAnswer(e.target.value, index, question)}/>


                </Fragment>
            )
        }
        if (question && question.type === 'date') {
            return (
                <Fragment key={index}>
                    <MaskedInput id={`q-${index}`}
                                 type="text"
                                 inputMode={question.inputMode}
                                 className={question.classNames}
                                 mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
                                 onFocus={() => saveProgress(question.save)}
                                 {...register(question.register, {validate: value => value !== ""})}
                                 placeholder={question.question}
                                 onChange={(e) => saveAnswer(e.target.value, index, question)}
                    />
                </Fragment>
            )
        }
        if (question && question.type === 'phone') {
            return (
                <Fragment key={index}>
                    <MaskedInput id={`q-${index}`}
                                 type="text"
                                 inputMode={question.inputMode}
                                 className={question.classNames}
                                 mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                 {...register(question.register, {validate: value => value !== ""})}
                                 onFocus={() => saveProgress(question.save)}
                                 placeholder={question.question}
                                 onChange={(e) => saveAnswer(e.target.value, index, question)}/>
                </Fragment>
            )
        }
        if (question && question.type === 'text') {
            return (
                <Fragment key={index}>
                    {
                        errorIndex.includes(index) &&
                        <div className="error--msg">{question.error}</div>
                    }
                    <input id={`q-${index}`}
                           type="text"
                           inputMode={question.inputMode}
                           className={question.classNames}
                           {...register(question.register)}
                           onFocus={() => saveProgress(question.save)}
                           placeholder={question.question}
                           maxLength={question.rules ? question.rules.maxDigits : 90}
                           onChange={(e) => saveAnswer(e.target.value, index, question)}
                    />
                </Fragment>
            )
        }
    }

    const resetForm = () => {
        setDisplayResults(false);
        setDisplayForm(true);
        setResults(null);
        LoanForm.reset();
        setAnswers([{}]);
    }
    const checkLoanOffers = (data) => {

        // store masked inputs in state so that if an error is returned from the server, they will repopulate

        // console.log(errors)
        // check that the errorIndex is empty before sending
        if (errorIndex.length > 0) {
            // take user to the input and highlight box in red
            // console.log(errorIndex)
            return;
        }


        setDisplayForm(false);
        setLoadingResults(true);

        // let buildRequest = answers.map(a => {
        //     const container = {};
        //     container[a.name] = a.answer;
        //     return container;
        // });


        axios.post('/loans/get-loan-offers', {
            data,
            session_uuid: session_uuid,
            partner_name: partnerName
        }).then((response) => {
            setResults(response.data.loan)
            setLoadingResults(false);
            setDisplayResults(true);

            // console.log('loan', response.data.loan)

        }).catch(error => {
            setDisplayForm(true);
            setLoadingResults(false);

            const SSN = document.getElementById('q-17');
            SSN.value = '000-00-0000';

            // todo: fix this error to display on the client side
            let er = Object.values(error.response.data.errors);
            er = er.flat();
            // console.log(er)
            setFormErrors(er)
        })
    }


    return (
        <main id="start-loan" className="question-container">
            {
                displayForm &&
                <>
                    <div className="section-title_text pb-4 gold-gradient">
                        Let's Find That Perfect Loan <span className="break-desktop">Just for You.</span>
                    </div>
                    {
                        formErrors.length > 0 &&
                        <Fragment>
                            <div className="form-errors">
                                {
                                    formErrors.map(er => (
                                        <div>{er}</div>
                                    ))
                                }
                            </div>
                        </Fragment>
                    }
                    <FormProvider {...LoanForm}>
                        <form id="question__form">
                            <SceneController globalSceneOptions={{triggerHook: 'onLeave'}}>
                                <Scene duration={'100%'} pin="#step-one" triggerElement="#step-one">
                                    <div className="panel">
                                        <Step1
                                            questions={questions}
                                            start={0}
                                            end={2}
                                            renderQuestion={renderQuestion}
                                        />
                                    </div>
                                </Scene>

                                <Scene duration={'100%'} pin="#step-two" triggerElement="#step-two">
                                    <div className="panel">
                                        <Step2
                                            questions={questions}
                                            renderQuestion={renderQuestion}
                                            start={3}
                                            end={8}
                                        />
                                    </div>
                                </Scene>

                                <Scene duration={'100%'} pin="#step-2b" triggerElement="#step-2b">
                                    <div className="panel">
                                        <Step2b
                                            questions={questions}
                                            renderQuestion={renderQuestion}
                                            start={9}
                                            end={14}
                                        />
                                    </div>
                                </Scene>

                                <Scene duration={'100%'} pin="#step-2c" triggerElement="#step-2c">
                                    <div className="panel">
                                        <Step2c
                                            questions={questions}
                                            renderQuestion={renderQuestion}
                                            start={15}
                                            end={16}
                                            startB={17}
                                            endB={18}
                                        />
                                    </div>
                                </Scene>

                                <Scene duration={300} pin="#step-three" triggerElement="#step-three">
                                    <div className="panel">
                                        <Step3 config={props.config} register={register} submit={LoanForm.handleSubmit(checkLoanOffers)}/>
                                    </div>
                                </Scene>
                            </SceneController>
                            <input name="session_uuid" type="hidden" value={session_uuid}/>

                        </form>


                    </FormProvider>
                </>
            }
            {
                loadingResults &&
                <>
                    <div className="section-title_text gold-gradient">
                        We're in the Process of Finding<br/>
                        <span>Your Offers.</span>
                    </div>
                    <div className="loading-results">
                        <div/>
                        <Loader type="Audio" color="#47b365" height={92} width={124}/>
                        <div/>
                    </div>
                </>
            }
            {
                results &&
                <Results resetForm={resetForm} results={results}/>
            }
        </main>
    )

}

export default Questions;
